import React from "react";
import { Box } from "@mui/material";
import { t } from "@lingui/macro";
import { withSnackbar, WithSnackbarProps } from "notistack";
import NavigationBack from "commons/navigation/navigation-back/navigation-back";
import {ErrorResponseApi} from "models/response";
import {CreateUserState} from "./models";
import ZPlayLoader from "commons/zplay-loader";
import { UpdateUserRequest } from "models/request";
import CreateAndEditUser from "components/backoffice/user/create-and-edit-user/create-and-edit-user";
import UserService from "services/user-service";


class CreateUser extends React.Component<WithSnackbarProps, CreateUserState> {

    constructor(props: any) {
        super(props);

        this.state={
            isLoading: false,
        }
    }

    private checkRequest = (request : UpdateUserRequest): boolean =>{
        let errorsArray: string[] = [];

        if(request.name === "" || !request.name)
            errorsArray.push(t({
                id: "cu-no-name-create-user",
                message: "È necessario inserire il nome"
            }));

        if(request.surname === "" || !request.surname)
            errorsArray.push(t({
                id: "cu-no-surname-create-user",
                message: "È necessario inserire il cognome"
            }));

        if(request.email === "" || !request.email)
            errorsArray.push(t({
                id: "cu-no-email-create-user",
                message: "È necessario inserire la mail"
            }));

        if(!request.role)
            errorsArray.push(t({
                id: "cu-no-role-create-user",
                message: "È necessario inserire il ruolo"
            }));

        if (errorsArray.length > 0)
            this.props.enqueueSnackbar(errorsArray.join(", "),
                { variant: "error" });

        return errorsArray.length === 0;

    }

    private submitForm = (request: UpdateUserRequest) => {
        if(!this.checkRequest(request))
            return

        this.setState(() => ({
            isLoading: true
        }))

        UserService.createUser(request, this.CreateUserSuccessCallback, this.CreateUserErrorCallback);
    };


    CreateUserSuccessCallback = (data: any) => {
        this.setState(() => ({
            isLoading: false
        }))

        this.props.enqueueSnackbar(t({
            id: "cu-success-create-user",
            message: "L'utente è stato creato"
        }), {
            variant: "success",
        })
    }

    CreateUserErrorCallback = (err: ErrorResponseApi) => {
        this.setState(() => ({
            isLoading: false,
        }));

        this.props.enqueueSnackbar(t({
            id: "cu-error-create-user",
            message: "Si è verificato un errore. Non è stato possibile creare l'utente"
        }), {
            variant: "error",
        });
    }

    render() {
        return (
            <Box sx={{ p: 5 }}>
                {this.state.isLoading && <ZPlayLoader />}
                <NavigationBack/>
                <Box maxWidth={"1000px"} padding={"30px 10px 10px"} margin={"0 auto"}>
                    {!this.state.isLoading && <CreateAndEditUser
                        user={null}
                        onSubmit={this.submitForm}
                    />}
                </Box>
            </Box>
        );
    }
}

export default withSnackbar(CreateUser);